var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('breadcrumb-default'),_c('breadcrumb-separator'),_c('breadcrumb-slot'),_c('breadcrumb-alignment')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }